import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { X } from 'lucide-react'
import { Button } from '../ui/button'
import { Textarea } from '../ui/textarea'
import axios from 'axios'
import toast from '../../utilities/toast'

function ReportDialog({ isOpen, onClose, conversationId }) {
  const [reason, setReason] = useState('')
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [error, setError] = useState(null)

  const handleSubmit = async () => {
    if (!reason.trim()) return

    setIsSubmitting(true)
    setError(null)

    try {
      await axios.post('/api/conversation_reports', {
        conversation_id: conversationId,
        reason: reason.trim()
      })
      setReason('')
      toast.success('Report submitted. Our team will review it.')
      onClose()
    } catch {
      setError('Failed to submit report. Please try again.')
      toast.error('Failed to submit report')
    } finally {
      setIsSubmitting(false)
    }
  }

  if (!isOpen) return null

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 p-4">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-md">
        <div className="flex items-center justify-between p-4 border-b border-gray-200">
          <h2 className="text-lg font-semibold text-gray-900">Report Issue</h2>
          <Button onClick={onClose} variant="ghost" size="icon">
            <X className="w-5 h-5" />
          </Button>
        </div>

        <div className="p-4">
          <p className="text-sm text-gray-600 mb-4">
            Please describe the issue with this conversation. Our team will review your report.
          </p>

          <Textarea
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            placeholder="Describe the issue..."
            className="min-h-[120px]"
            maxLength={1000}
          />

          {error && <p className="text-sm text-red-600 mt-2">{error}</p>}
        </div>

        <div className="flex items-center justify-end gap-2 p-4 border-t border-gray-200">
          <Button onClick={onClose} variant="outline" disabled={isSubmitting}>
            Cancel
          </Button>
          <Button
            onClick={handleSubmit}
            disabled={!reason.trim() || isSubmitting}
            className="bg-red-600 hover:bg-red-700"
          >
            {isSubmitting ? 'Submitting...' : 'Submit Report'}
          </Button>
        </div>
      </div>
    </div>
  )
}

ReportDialog.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  conversationId: PropTypes.string
}

export default ReportDialog
